import { Component, OnInit ,Input, Output, EventEmitter} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { fciWebsiteService } from '../../service/fci-website.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { CustomServiceService } from '../../service/custom-service.service';
import { environment } from 'src/environments/environment'; 
declare let $ : any;
import * as CryptoJS from 'crypto-js';
import { Buffer } from 'buffer';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-website-inner-layout',
  templateUrl: './website-inner-layout.component.html',
  styleUrls: ['./website-inner-layout.component.css']
}) 
export class WebsiteInnerLayoutComponent implements OnInit {
   
  constructor(private fciwebservice: fciWebsiteService, private routerparam: ActivatedRoute, private route: Router, public encDec: EncryptDecryptService,private httpservice: CustomServiceService, public translate: TranslateService) { } 
  param_menualias:any;
  mainmenuid:any;
  backendUrl = environment.serviceURL; 
  pageAlias:any="";
  menuAlias:any="";
  employee_con:any="";
  showEmpMen:boolean=false;
  language:any = '';
  CURRENT_ZONE_ID:any = environment.ZONE_ID;
  CURRENT_REGION_ID:any = environment.REGION_ID;
  CURRENT_ZONE_CODE:any = environment.ZONE_CODE;
  CURRENT_REGION_CODE:any = environment.REGION_CODE;
  datetime:any = this.httpservice.currentDateTime(); 
  ngOnInit(): void { 
    this.language = sessionStorage.getItem('locale');//dynamic
   this.employee_con = this.routerparam.snapshot.queryParamMap.get('emp');
   this.menuAlias = this.routerparam.snapshot.paramMap.get('aliasName');
   if(this.employee_con==null){
    this.ContentPageDetials(this.menuAlias);
   } else {
    this.pageAlias = this.routerparam.snapshot.paramMap.get('aliasName');
    this.getEmployeeCornerDtl(this.encDec.decText(this.employee_con));
   }
  }
 
  ngAfterViewInit(): void {
    //FOR SCROLLING TO TOP WHEN COMPONENT LOADS
    // $('html, body').scrollTop(0);
  }
 

emp_apires:any;
emp_dtl:any={'title':'',titleInHindi:''};
getEmployeeCornerDtl(id:any){
  let params = [
    {
      "secSlNo": 1,
      "offSet": 0,
      "noOfRecords": 0,
      "orderBy": [],
      "condition": [ 
        { "columnName": "tinPublishStatus", "operator": "=", "value": "1", "joinoperator": "and" },
        { "columnName": "bitDeletedFlag", "operator": "=", "value": "0", "joinoperator": "and" },
        { "columnName": "intId", "operator": "=", "value":id, "joinoperator": "and" },
      ],
      "viewParameters": ""
    }];
  this.httpservice.EmpeeloyCorner(params).subscribe((response: HttpEvent<any>) => {
    switch (response.type) {
      case HttpEventType.Sent:
        //console.log('Sent' + HttpEventType.Sent);
        break;
      case HttpEventType.ResponseHeader:
        //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
        break;
      case HttpEventType.UploadProgress:
        //this.evenTotal = response.total;
        //this.progress = Math.round(response.loaded / this.evenTotal * 100);
        break; 
      case HttpEventType.Response:
      this.emp_apires = response.body;
      let respData = this.emp_apires.RESPONSE_DATA;
      let respToken = this.emp_apires.RESPONSE_TOKEN;
      let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
      if (respToken == verifyToken) { 
        let response_: any = Buffer.from(respData, 'base64');
        response_ = JSON.parse(response_);
        if(response_.result.sec_1.length > 0){
          this.emp_dtl=response_.result.sec_1[0];
          this.showEmpMen=true;
        }
      } 
    }
  });
}







  hasNavMenu:any=false;
  global_menu:any={};
  primary_menu:any={};
  secondary_menu:any={};
  tertiary_menu:any={};
  has_global_menu:any=false;
  has_primary_menu:any=false;
  has_secondary_menu:any=false;
  has_tertiary_menu:any=false;
  tertiaryList:any=[];
  NavMenulist:any=[];
  totalNavMenu:any=0; 
  check_total_current_menu:any=0;
  current_menu:any={};
  navmenuloadCss = "background-color: #167a44; height: 100%;";
  p_apirespons: any;
  showComponent:boolean=false;
  ContentPageDetials(alias:any) {
   
    let params = {
      "zone_id": environment.ZONE_ID,
      "zone_code": environment.ZONE_CODE,
      "region_id": environment.REGION_ID,
      "region_code": environment.REGION_CODE,
      'VCHMENUALIAS':alias
    };  
    this.httpservice.getContentPageDetials(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break; 
        case HttpEventType.Response:
        this.p_apirespons = response.body;
        let respData = this.p_apirespons.RESPONSE_DATA;
        let respToken = this.p_apirespons.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) { 
          let response_: any = Buffer.from(respData, 'base64');
          response_ = JSON.parse(response_);
          this.p_apirespons = response_.original;
          if(this.p_apirespons.status==true){ 
            if(this.p_apirespons.check_total_current_menu > 0){
            this.pageAlias = this.p_apirespons.current_menu.CONTENT_PAGE_ID;
            this.hasNavMenu = this.p_apirespons.hasNavMenu;
            this.global_menu = this.p_apirespons.global_menu;
            this.primary_menu = this.p_apirespons.primary_menu;
            this.secondary_menu = this.p_apirespons.secondary_menu;
            this.tertiary_menu = this.p_apirespons.tertiary_menu;
            this.tertiaryList = this.p_apirespons.tertiaryList;
            this.has_global_menu = this.p_apirespons.has_global_menu;
            this.has_primary_menu = this.p_apirespons.has_primary_menu;
            this.has_secondary_menu = this.p_apirespons.has_secondary_menu;
            this.has_tertiary_menu = this.p_apirespons.has_tertiary_menu;
            this.NavMenulist = this.p_apirespons.NavMenulist;
            this.totalNavMenu = this.p_apirespons.totalNavMenu;
            this.check_total_current_menu = this.p_apirespons.check_total_current_menu;
            this.current_menu = this.p_apirespons.current_menu;
            this.navmenuloadCss = "height: 100%;";
            this.showComponent=true;
            }
          } 
      
        } 
      }
    });
  }








  goToPluginPage(link:any,menudtl:any)
  {
   sessionStorage.removeItem(btoa(menudtl.selectPlugin));
   sessionStorage.setItem(btoa(menudtl.selectPlugin),JSON.stringify(menudtl));
   this.route.navigateByUrl('/', { skipLocationChange: true }).then(() =>
   this.route.navigate([link]));
  }



 

  goToExtLink(url:any)
  {
     Swal.fire({
      title: 'You are being redirected to an external website. Please note that Food Corporation of India (FCI) cannot be held responsible for external websites content & privacy policies.',
      text: 'Are you sure?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        window.open(url, '_blank');
        //window.location.href = `${url} target="_blank"`;
        // var a = document.createElement('a');
        // a.target="_blank";
        // a.href=url;
        // a.text='External link';
        // a.id='external_url';
        // a.click();
        // document.getElementById('external_url')?.remove();
    }
  });
  }


 

  goToContentPage(menu:any)
  {
      this.route.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.route.navigate(['./view'+'/'+menu.VCHMENUALIAS]));
   } 







  htmldecode(str: any){
    return this.encDec.decodeHtml(str);
  }

 
}
